(() => {
  if (window.__COSTA_CART_DRAWER_REFRESH_INIT__) return;
  window.__COSTA_CART_DRAWER_REFRESH_INIT__ = true;

  const ROOT =
    (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root
      : "/";

  async function fetchSectionHTML() {
    const res = await fetch(`${ROOT}?section_id=cart-drawer`, {
      method: "GET",
      headers: { "Accept": "text/html" }
    });
    if (!res.ok) return null;
    return res.text();
  }

  async function refreshDrawerParts() {
    try {
      const html = await fetchSectionHTML();
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, "text/html");
      const newDrawer = doc.querySelector("#cart-drawer") || doc.querySelector("cart-drawer");
      const curDrawer = document.querySelector("#cart-drawer") || document.querySelector("cart-drawer");
      if (!newDrawer || !curDrawer) return;

      // ✅ só estas partes (não mexer no footer nem no dialog)
      const newItems = newDrawer.querySelector(".cart-drawer__line-items");
      const curItems = curDrawer.querySelector(".cart-drawer__line-items");
      if (newItems && curItems) curItems.replaceWith(newItems);

      const newTotals = newDrawer.querySelector(".cart-drawer__totals");
      const curTotals = curDrawer.querySelector(".cart-drawer__totals");
      if (newTotals && curTotals) curTotals.replaceWith(newTotals);

      const newDiscounts = newDrawer.querySelectorAll(".cart-cart-level-discounts, .cart-drawer__footer .badge, .cart-drawer__footer .h-stack");
      // (não obrigatório — deixo de fora para não tocar no footer)

      const newCount = newDrawer.querySelector("cart-count");
      const curCount = curDrawer.querySelector("cart-count");
      if (newCount && curCount) curCount.replaceWith(newCount);

    } catch (e) {
      console.warn("[cart-drawer-refresh] failed", e);
    }
  }

  // add-ons mexeram no carrinho -> refresca só as partes
  document.addEventListener("cart:addons:updated", () => {
    setTimeout(refreshDrawerParts, 80);
  });

  // salvar observações -> depois do update, refresca só as partes
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#cart-drawer-note [is='close-button'], #cart-drawer-note button, #cart-drawer-note a");
    if (!btn) return;

    const label = (btn.textContent || "").trim().toLowerCase();
    if (!label.includes("salvar") && !label.includes("guardar") && !label.includes("save")) return;

    setTimeout(refreshDrawerParts, 450);
  });
})();
